<mat-card>
  <app-card-header
    title="Cambiar modo"
    icono="settings_suggest"
    [botonCerrar]="true"
    (cerrar)="dialogRef.close()"
  ></app-card-header>

  <form [formGroup]="formGroup" (ngSubmit)="onSubmit()" autocomplete="off">
    <mat-card-content class="card-content-crear">
      <section class="inputs-group">
        <ng-select
          [items]="modoLuminaria"
          formControlName="mode"
          placeholder="Seleccionar modo"
          style="width: 100%"
          multiple="false"
          searchable="false"
          appendTo="body"
          notFoundText="Sin resultados"
        ></ng-select>
      </section>
    </mat-card-content>

    <mat-card-actions class="actions-create">
      <app-button
        matType="mat-fab extended"
        color="neutral"
        (click)="dialogRef.close()"
        text="Cancelar"
        icon="close"
      ></app-button>

      <app-button
        matType="mat-fab extended"
        [disabled]="!formGroup?.valid || loading"
        color="primary"
        text="Enviar"
        icon="send"
        type="submit"
      ></app-button>
    </mat-card-actions>
  </form>
</mat-card>
